import Menu from '@/api/QMenuItem'

const getDefaultState = () => {
  return {
    currentMenu: {},
    menus: [],
  }
}

// initial state
const state = getDefaultState()

const getters = {}

const actions = {
  // async functions trow errors to view
  async ADD_MENU({ dispatch, rootGetters }, menu) {
    await Menu.post(rootGetters.centro_id, menu)
    dispatch('GET_MENUS')
  },

  async DELETE_MENU({ dispatch, rootGetters }, menu) {
    await Menu.delete(rootGetters.centro_id, menu.id)
    dispatch('GET_MENUS')
  },

  async UPDATE_MENU({ dispatch, rootGetters }, menu) {
    await Menu.put(rootGetters.centro_id, menu.id, menu)
    dispatch('GET_MENUS')
  },

  async COPY_FROM_PARENT({ dispatch, rootGetters }) {
    await Menu.copyFromParent(rootGetters.centro_id)
    dispatch('GET_MENUS')
  },

  async GET_MENU({ commit, rootGetters }, id) {
    const response = await Menu.put(rootGetters.centro_id, id)
    commit('SET_CURRENT_MENU', response.data)
  },

  async GET_MENUS({ commit, rootGetters }) {
    try {
      const response = await Menu.getQMenuItemsFull(rootGetters.centro_id)
      commit('SET_MENUS', response)
    } catch (error) {
      console.error(
        `Error ${error.response.status} getting list of Menus`
      );
    }
  },
}

const mutations = {
  SET_CURRENT_MENU(state, menu) {
    state.currentMenu = menu
  },

  SET_MENUS(state, menus) {
    let tmpMenus = []
    flatten(tmpMenus, menus, 0)
    state.menus = tmpMenus
  },
}

/* Calls itself to flatten the menus tree */
function flatten(state, menus, level) {
  menus.map(menu => {
    menu.indent = level
    state.push(menu)
    if (menu.items && menu.items.length) flatten(state, menu.items, level + 1)
  })
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
